import { IIncentivePortfolioSignals, IIncentiveContract, IIncentiveCategoryResponse, IIncentiveDetailContract, IIncentiveLookupResponse } from "../contracts/Incentive";
import { deleteDataAsync, downloadDataAsync, getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { IIncentiveCollection } from "./interfaces/IIncentive";

let incentivePrefix = "/Incentive/";

export const Incentive: IIncentiveCollection = {
  portfolioSignals: async (companyId: number) => {
    return await getDataAsync<IIncentivePortfolioSignals>(
      `${incentivePrefix}Signals/Portfolio/${companyId}`,
      ""
    );
  },
  eligibleIncentivesByPropertyId: async (
    propertyId: number,
    updateSummary?: boolean
  ) => {
    const params = new URLSearchParams();
    if (updateSummary) {
      params.set("updateSummary", "true");
    }
    const query = params.toString() ? `?${params.toString()}` : "";
    const response = await getDataAsync<IIncentiveContract[]>(
      `${incentivePrefix}Eligible/${propertyId}${query}`,
      ""
    );
    return response;
  },
  getIncentiveDetailById: async (
    incentiveId: number,
    options: {
      propertyId?: number | null;
      screeningRunGuid?: string | null;
      updateSummary?: boolean;
    }
  ) => {
    const params = new URLSearchParams();
    if (options.propertyId) {
      params.set("propertyId", String(options.propertyId));
    }
    if (options.screeningRunGuid) {
      params.set("screeningRunGuid", options.screeningRunGuid);
    }
    if (options.updateSummary) {
      params.set("updateSummary", "true");
    }
    const response = await getDataAsync<IIncentiveDetailContract>(
      `${incentivePrefix}${incentiveId}?${params.toString()}`,
      ""
    );
    return response;
  },
  getCategoriesAsync: async () => {
    const response = await getDataAsync<IIncentiveCategoryResponse[]>(
      `${incentivePrefix}Categories`,
      ""
    );
    return response;
  },
  downloadSummaryByPropertyId: async (
    propertyId: number,
    format: "pdf" | "docx"
  ) => {
    const response = await downloadDataAsync(
      `${incentivePrefix}Summary/${propertyId}?format=${format}`
    );
    return response;
  },
  searchIncentivesAsync: async (query: string = "", limit: number = 25) => {
    const params = new URLSearchParams();
    if (query.trim()) {
      params.set("query", query.trim());
    }
    params.set("limit", String(limit));
    const response = await getDataAsync<IIncentiveLookupResponse[]>(
      `${incentivePrefix}Search?${params.toString()}`,
      ""
    );
    return response;
  },
  addManualLinkAsync: async (propertyId: number, incentiveId: number, reason: string | null) => {
    const response = await postDataAsync<boolean>(`${incentivePrefix}ManualLink`, {
      propertyId,
      incentiveId,
      reason,
    });
    return response;
  },
  removeManualLinkAsync: async (propertyId: number, incentiveId: number) => {
    const response = await deleteDataAsync<boolean>(
      `${incentivePrefix}ManualLink/${propertyId}/${incentiveId}`,
      null
    );
    return response;
  },
};
